import { render, staticRenderFns } from "./FundsTransferProviderPortal.vue?vue&type=template&id=859eb428&"
import script from "./FundsTransferProviderPortal.vue?vue&type=script&lang=js&"
export * from "./FundsTransferProviderPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports